import { WorkflowList } from '~/components/Workflow/WorkflowListPage/WorkflowList';

const WorkflowBuilderList = () => {
  return <WorkflowList />;
};

export default WorkflowBuilderList;
